<template>
  <div class="monitor" style="font-size:16px;width:100%;background:#eff1f5">
    <div class="content">
      <div class="yuliang" ref="yuliang" style="margin-top:0;">
        <div class="select" ref="districtrainOperation">
          <span class="desc">起止时间:</span>
          <div style="display: inline-block;">
              <el-date-picker
              v-model="query.beginTime"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="选择开始时间"
              :picker-options="Global.pickerOptionsStart(query.endTime)"
              default-time="08:00:00">
            </el-date-picker>
            <span class="desc">至</span>
            <el-date-picker
              v-model="query.endTime"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="选择结束时间"
              :picker-options="Global.pickerOptionsEnd(query.beginTime)"
              default-time="08:00:00">
            </el-date-picker>
          </div>
          <span id="select" @click="tabledata">查询</span>
          <span id="export" @click="exportExcel">
            <span class="export-icon"></span>导出
          </span>
        </div>
        <div class="tableDiv" ref="tableDiv">
          <table>
            <tr>
              <th>河网水位站</th>
              <th>水 位</th>
              <th>雨 量</th>
              <th>雨量站</th>
              <th>雨 量</th>
            </tr>
            <tr v-for="(item, i) in data.riverStations" v-bind:key="item.stid" :class="{even: i % 2 == 1}">
              <td>{{item.stnm}}</td>
              <td>{{item.water}}</td>
              <td>{{item.rain}}</td>
              <td>{{data.rainStations[i].stnm}}</td>
              <td>{{data.rainStations[i].rain}}</td>
            </tr>
            <tr>
              <th>排涝闸站</th>
              <th>闸上水位</th>
              <th>雨 量</th>
              <th colspan="2">闸下水位</th>
            </tr>
            <tr v-for="(item, i) in data.upDamStations" v-bind:key="item.stid" :class="{even: i % 2 == 1}">
              <td>{{item.stnm}}</td>
              <td>{{item.water}}</td>
              <td>{{item.rain}}</td>
              <td>{{data.underDamStations[i].stnm}}</td>
              <td>{{data.underDamStations[i].rain}}</td>
            </tr>
            <tr>
              <th>水库站</th>
              <th>库水位</th>
              <th>雨 量</th>
              <th colspan="2">正常水位（相应库容）</th>
            </tr>
            <tr v-for="(item, i) in data.reservoirStations" v-bind:key="item.stid" :class="{even: i % 2 == 1}">
              <td>{{item.stnm}}</td>
              <td>{{item.water}}</td>
              <td>{{item.rain}}</td>
              <td colspan="2">{{item.warningWater}}({{item.storage}})</td>
            </tr>
            <tr>
              <th>所有站点雨量平均值</th>
              <th colspan="4">{{data.avgRain}}</th>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import monitorTypes from '@/store/types/monitor'
export default {
  data () {
    return {
      query: {
        beginTime: '',
        endTime: ''
      },
      data: {}
    }
  },
  methods: {
    tabledata () {
      this.$store.dispatch(monitorTypes.GET_RAIN_WATER_REPORT, this.query).then(data => {
        this.data = data.data
      })
    },
    async exportExcel () {
      let postResult = await this.$store.dispatch(monitorTypes.GET_RAIN_WATER_REPORT_EXPORT, this.query)
      let blob = new Blob([postResult])
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = '永嘉县水雨情信息报表.xls'
      link.click()
      link.remove()
    }
  },
  created () {
    let now = new Date()
    var preDate = new Date(now.getTime() - 24 * 60 * 60 * 1000) // 前一天
    this.query.beginTime = this.Global.timeFormat(preDate)
    this.query.endTime = this.Global.timeFormat(now)
    this.tabledata()
  },
  mounted () {
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('content')
      this.$refs['yuliang'].style.height = (contentDiv[0].offsetHeight - 30) + 'px'
      this.$refs['tableDiv'].style.height = (this.$refs['yuliang'].offsetHeight - 20 - this.$refs['districtrainOperation'].offsetHeight) + 'px'
      // this.$refs['thead'].style.width = (this.$refs['tbody'].offsetWidth) + 'px'
      // this.$refs['tbody'].style.height = (this.$refs['tableDiv'].offsetHeight - this.$refs['thead'].offsetHeight) + 'px'
    })
  }
}
</script>
<style lang="less" src="@/assets/monitor.less" scoped>
</style>
<style lang="less" scoped>
.monitor {
  .tableDiv{
    color:#000;
    margin-top: 5Px;
    width: 98%;
    margin-left: 1%;
    overflow-y: scroll;
     table {
      width: 100%;
      font-size: 15px;
      thead{
        display:table;
        width:100%;
        height: 50px;
        table-layout:fixed;
        // width: calc( 100% - 1em );
        // margin-right:0.15rem;
      }
      tr {
        height: 50px;
        display:table;
        width:100%;
        table-layout:fixed;
        vertical-align:middle;
        th {
          text-align: center;
          border:1px solid rgb(235, 239, 246);
          background:rgb(245, 248, 251);
        }
        td {
          text-align: center;
          border:1px solid rgb(235, 239, 246);
        }
      }
      tr.even {
          background: rgb(232, 242, 251);
      }
      tr.odd {
        background: rgb(255, 255, 255);
      }
    }
  }
}
</style>
